import React, { Component } from 'react';

import Dashboard from '../shared/Dashboard';
import fulltextFilter from './fulltextFilter';

class App extends Component {
  constructor(props) {
    super(props);

    let items = drupalSettings.dashboardData;

    // Reverse array, the new items are at the end.
    items.reverse();

    // 2021-07-30: The client requests to delete this business rule.
    // Remove items with 'canEdit' === true.
    //items = items.filter(element => !element.canEdit);

    const newItemsApi = items
      .filter(element => element.newIndicator)
      .map(element => element.publicId);

    let newItemsCurrent = [];

    if (window.localStorage) {
      let newItemsStored = window.localStorage.getItem('dashboardTecLicenciablesNew');
      if (newItemsStored) {
        newItemsStored = newItemsStored.split(',');
        newItemsCurrent = newItemsApi.filter(element => (
          newItemsStored.indexOf(element) === -1
        ));
      }
      window.localStorage.setItem('dashboardTecLicenciablesNew', newItemsApi);
    }

    this.state = {
      items,
      newItems: newItemsCurrent,
    };
  }

  render() {
    const { items, newItems } = this.state;
    return (
      <Dashboard
        items={items}
        basePath="/dashboard/tecnologias-licenciables/"
        newItems={newItems}
        fulltextFilter={fulltextFilter}
      />
    );
  }
}

export default App;
